import { useFlags } from "launchdarkly-react-client-sdk";
import { defaultFlags, type FeatureFlagValue } from "providers/LaunchDarkly/featureFlags";

// `useFlags` directly (not the `providers/LaunchDarkly` wrapper) so the hook unit-tests
// without initializing the LD client at module load.
export const useScreeningQuestionnaireToggleEnabled = (): boolean => {
  const flags = useFlags<FeatureFlagValue>();
  const jobsPhased = flags["jobs-phased"] ?? defaultFlags["jobs-phased"];
  return jobsPhased >= 2;
};
